import type { SVGAttributes } from 'react';
import { IconSVG } from 'atto-svgs';
import React from 'react';

import type { VariantProp } from '../../common/colors';
import type { SpacingValue } from '../../common/sizing';
import type { ColorProps } from '../../utilities/shared/Color';
import { getVariantStyles, variantIconColor } from '../../common/variant';
import { styled } from '../../stitches.config';
import { colorCSS } from '../../utilities/shared/Color';

export type IconSize = SpacingValue;

export const Icons = {
  'access-control': IconSVG.AccessControl,
  'access-point': IconSVG.AccessPoint,
  'access-point-backup': IconSVG.AccessPointBackup,
  'access-point-cycle': IconSVG.AccessPointCycle,
  'access-point-rogue': IconSVG.AccessPointRogue,
  'access-point-scan': IconSVG.AccessPointScan,
  'access-points': IconSVG.AccessPoints,
  airplay: IconSVG.AirPlay,
  allowlist: IconSVG.Allowlist,
  alpha: IconSVG.Alpha,
  anchor: IconSVG.Anchor,
  antenna: IconSVG.Antenna,
  application: IconSVG.Application,
  archive: IconSVG.Archive,
  area: IconSVG.Area,
  'arrow-bidirectional': IconSVG.ArrowBidirectional,
  'arrow-down': IconSVG.ArrowDown,
  'arrow-left': IconSVG.ArrowLeft,
  'arrow-right': IconSVG.ArrowRight,
  'arrow-up': IconSVG.ArrowUp,
  'arrow-up-right': IconSVG.ArrowUpRight,
  'arrows-diagonal': IconSVG.ArrowsDiagonal,
  'arrows-diagonal-reverse': IconSVG.ArrowsDiagonalReverse,
  'arrows-move': IconSVG.ArrowsMove,
  'arrows-rotate': IconSVG.ArrowsRotate,
  'arrows-up-down': IconSVG.ArrowsUpDown,
  attach: IconSVG.Attach,
  attention: IconSVG.Attention,
  attributes: IconSVG.Attributes,
  automated: IconSVG.Automated,
  'auto-vpn': IconSVG.AutoVPN,
  backspace: IconSVG.Backspace,
  bell: IconSVG.Bell,
  'bell-crossed': IconSVG.BellCrossed,
  'bell-filled': IconSVG.BellFilled,
  beta: IconSVG.Beta,
  bgp: IconSVG.BGP,
  'bill-of-materials': IconSVG.BillOfMaterials,
  block: IconSVG.Block,
  blocklist: IconSVG.Blocklist,
  bookmark: IconSVG.Bookmark,
  'bookmark-filled': IconSVG.BookmarkFilled,
  'bookmark-one': IconSVG.BookmarkOne,
  'bookmark-three': IconSVG.BookmarkThree,
  'bookmark-two': IconSVG.BookmarkTwo,
  bug: IconSVG.Bug,
  calculator: IconSVG.Calculator,
  calendar: IconSVG.Calendar,
  cards: IconSVG.Cards,
  'captive-portal': IconSVG.CaptivePortal,
  cellular: IconSVG.Cellular,
  changelog: IconSVG.Changelog,
  channel: IconSVG.Channel,
  'channel-cycle': IconSVG.ChannelCycle,
  'chart-bar': IconSVG.ChartBar,
  'chart-line': IconSVG.ChartLine,
  chat: IconSVG.Chat,
  checkmark: IconSVG.Checkmark,
  'checkmark-circle': IconSVG.CheckmarkCircle,
  'chevron-down': IconSVG.ChevronDown,
  'chevron-left': IconSVG.ChevronLeft,
  'chevron-right': IconSVG.ChevronRight,
  'chevrons-horizontal': IconSVG.ChevronsHorizontal,
  'chevrons-vertical': IconSVG.ChevronsVertical,
  'chevron-up': IconSVG.ChevronUp,
  client: IconSVG.Client,
  'client-vpn': IconSVG.ClientVPN,
  clock: IconSVG.Clock,
  cloud: IconSVG.Cloud,
  'cloud-checkmark': IconSVG.CloudCheckmark,
  'cloud-cross': IconSVG.CloudCross,
  'cloud-down': IconSVG.CloudDown,
  'cloud-up': IconSVG.CloudUp,
  cloudflare: IconSVG.Cloudflare,
  code: IconSVG.Code,
  cog: IconSVG.Cog,
  columns: IconSVG.Columns,
  command: IconSVG.Command,
  company: IconSVG.Company,
  compass: IconSVG.Compass,
  connect: IconSVG.Connect,
  connection: IconSVG.Connection,
  'connection-connected': IconSVG.ConnectionConnected,
  'connection-disassociated': IconSVG.ConnectionDisassociated,
  'connection-failed': IconSVG.ConnectionFailed,
  console: IconSVG.Console,
  copy: IconSVG.Copy,
  cross: IconSVG.Cross,
  'cross-circle': IconSVG.CrossCircle,
  crown: IconSVG.Crown,
  cut: IconSVG.Cut,
  data: IconSVG.Data,
  'data-cycle': IconSVG.DataCycle,
  description: IconSVG.Description,
  design: IconSVG.Design,
  detection: IconSVG.Detection,
  'detection-network': IconSVG.DetectionNetwork,
  'detection-wireless': IconSVG.DetectionWireless,
  dhcp: IconSVG.DHCP,
  diagnostics: IconSVG.Diagnostics,
  digest: IconSVG.Digest,
  dns: IconSVG.DNS,
  'dns-generate-maps': IconSVG.DNSGenerateMaps,
  'dns-security': IconSVG.DNSSecurity,
  dock: IconSVG.Dock,
  document: IconSVG.Document,
  'document-csv': IconSVG.DocumentCSV,
  'document-png': IconSVG.DocumentPNG,
  documentation: IconSVG.Documentation,
  documents: IconSVG.Documents,
  download: IconSVG.Download,
  'drag-horizontal': IconSVG.DragHorizontal,
  'drag-vertical': IconSVG.DragVertical,
  'dynamic-vlan': IconSVG.DynamicVLAN,
  email: IconSVG.Email,
  ethernet: IconSVG.EthernetUp,
  'ethernet-config': IconSVG.EthernetConfig,
  'ethernet-down': IconSVG.EthernetDown,
  'ethernet-down-cycle': IconSVG.EthernetDownCycle,
  'ethernet-up': IconSVG.EthernetUp,
  'ethernet-up-cycle': IconSVG.EthernetUpCycle,
  'ethernet-usage': IconSVG.EthernetUsage,
  export: IconSVG.Export,
  'eye-closed': IconSVG.EyeClosed,
  'eye-open': IconSVG.EyeOpen,
  filter: IconSVG.Filter,
  fingerprint: IconSVG.Fingerprint,
  firewall: IconSVG.Firewall,
  flag: IconSVG.Flag,
  'flash-leds': IconSVG.FlashLEDs,
  'floor-plan': IconSVG.FloorPlan,
  folder: IconSVG.Folder,
  gavel: IconSVG.Gavel,
  globe: IconSVG.Globe,
  'globe-one': IconSVG.GlobeOne,
  'globe-three': IconSVG.GlobeThree,
  'globe-two': IconSVG.GlobeTwo,
  group: IconSVG.Group,
  heart: IconSVG.Heart,
  'heart-filled': IconSVG.HeartFilled,
  'heart-half': IconSVG.HeartHalf,
  'high-availability': IconSVG.HighAvailability,
  home: IconSVG.Home,
  honeypot: IconSVG.Honeypot,
  'host-monitoring': IconSVG.HostMonitoring,
  'hotspot-2.0': IconSVG.Hotspot20,
  hose: IconSVG.Hose,
  hourglass: IconSVG.Hourglass,
  hub: IconSVG.Hub,
  inbox: IconSVG.Inbox,
  'inbox-unread': IconSVG.InboxUnread,
  information: IconSVG.Information,
  insights: IconSVG.Insights,
  inspector: IconSVG.Inspector,
  integrations: IconSVG.Integrations,
  interface: IconSVG.Interface,
  'inter-vlan': IconSVG.InterVLAN,
  'ip-address': IconSVG.IPAddress,
  'ip-forward': IconSVG.IPForward,
  'ipsec-tunnel': IconSVG.IPSecTunnel,
  issue: IconSVG.Issue,
  jitter: IconSVG.Jitter,
  key: IconSVG.Key,
  keyboard: IconSVG.Keyboard,
  'life-ring': IconSVG.LifeRing,
  lightbulb: IconSVG.Lightbulb,
  lightning: IconSVG.Lightning,
  'lightning-cycle': IconSVG.LightningCycle,
  'lightning-filled': IconSVG.LightningFilled,
  list: IconSVG.List,
  location: IconSVG.Location,
  locations: IconSVG.Locations,
  log: IconSVG.Log,
  'mac-address': IconSVG.MACAddress,
  magnet: IconSVG.Magnet,
  map: IconSVG.Map,
  megaphone: IconSVG.Megaphone,
  menu: IconSVG.Menu,
  meter: IconSVG.Meter,
  microchip: IconSVG.Microchip,
  'microchip-checkmark': IconSVG.MicrochipCheckmark,
  'microchip-clock': IconSVG.MicrochipClock,
  'microchip-cross': IconSVG.MicrochipCross,
  'microchip-upgrade': IconSVG.MicrochipUpgrade,
  minus: IconSVG.Minus,
  'minus-circle': IconSVG.MinusCircle,
  'money-bag': IconSVG.MoneyBag,
  moon: IconSVG.Moon,
  'multicast-dns': IconSVG.MulticastDNS,
  nat: IconSVG.NAT,
  'network-ids': IconSVG.NetworkIDS,
  'network-wide': IconSVG.NetworkWide,
  noise: IconSVG.Noise,
  note: IconSVG.Note,
  observe: IconSVG.Observe,
  onboarding: IconSVG.Onboarding,
  operator: IconSVG.Operator,
  outlet: IconSVG.Outlet,
  'overflow-horizontal': IconSVG.OverflowHorizontal,
  'overflow-horizontal-circle': IconSVG.OverflowHorizontalCircle,
  'overflow-vertical': IconSVG.OverflowVertical,
  'packet-capture': IconSVG.PacketCapture,
  padlock: IconSVG.Padlock,
  'padlock-content': IconSVG.PadlockContent,
  'pane-bottom': IconSVG.PaneBottom,
  'pane-end': IconSVG.PaneEnd,
  'pane-left': IconSVG.PaneLeft,
  'pane-right': IconSVG.PaneRight,
  'pane-start': IconSVG.PaneStart,
  'pane-start-collapse': IconSVG.PaneStartCollapse,
  'pane-start-expand': IconSVG.PaneStartExpand,
  'pane-top': IconSVG.PaneTop,
  parts: IconSVG.Parts,
  paste: IconSVG.Paste,
  patching: IconSVG.Patching,
  pattern: IconSVG.Pattern,
  pause: IconSVG.Pause,
  pdu: IconSVG.PDU,
  pencil: IconSVG.Pencil,
  phone: IconSVG.Phone,
  picker: IconSVG.Picker,
  pin: IconSVG.Pin,
  ping: IconSVG.Ping,
  'ping-pong': IconSVG.PingPong,
  placeholder: IconSVG.Placeholder,
  play: IconSVG.Play,
  plus: IconSVG.Plus,
  'plus-circle': IconSVG.PlusCircle,
  policy: IconSVG.Policy,
  'port-forward': IconSVG.PortForward,
  power: IconSVG.Power,
  'power-cycle': IconSVG.PowerCycle,
  'power-distribution-unit': IconSVG.PDU,
  'power-history': IconSVG.PowerHistory,
  preferences: IconSVG.Preferences,
  printer: IconSVG.Printer,
  'priority-high': IconSVG.PriorityHigh,
  'priority-highest': IconSVG.PriorityHighest,
  'priority-low': IconSVG.PriorityLow,
  'priority-lowest': IconSVG.PriorityLowest,
  'priority-medium': IconSVG.PriorityMedium,
  probe: IconSVG.Probe,
  project: IconSVG.Project,
  protect: IconSVG.Protect,
  pulse: IconSVG.Pulse,
  qrcode: IconSVG.QRCode,
  question: IconSVG.Question,
  rack: IconSVG.Rack,
  radar: IconSVG.Radar,
  'radio-profile': IconSVG.RadioProfile,
  radius: IconSVG.Radius,
  'rate-limit': IconSVG.RateLimit,
  'read-only': IconSVG.ReadOnly,
  redo: IconSVG.Redo,
  reserve: IconSVG.Reserve,
  reset: IconSVG.Reset,
  ribbon: IconSVG.Ribbon,
  rocket: IconSVG.Rocket,
  route: IconSVG.Route,
  'round-trip': IconSVG.RoundTrip,
  routing: IconSVG.Routing,
  rules: IconSVG.Rules,
  save: IconSVG.Save,
  search: IconSVG.Search,
  'search-domain': IconSVG.SearchDomain,
  'search-scoped': IconSVG.SearchScoped,
  'search-service': IconSVG.SearchService,
  secure: IconSVG.Secure,
  service: IconSVG.Service,
  share: IconSVG.Share,
  ship: IconSVG.Ship,
  signout: IconSVG.Signout,
  sfp: IconSVG.SFP,
  'site-to-site': IconSVG.SiteToSite,
  'slide-horizontal': IconSVG.SlideHorizontal,
  'slide-vertical': IconSVG.SlideVertical,
  snowflake: IconSVG.Snowflake,
  sort: IconSVG.Sort,
  span: IconSVG.SPAN,
  spare: IconSVG.Spare,
  speaker: IconSVG.Speaker,
  'speed-high': IconSVG.SpeedHigh,
  'speed-low': IconSVG.SpeedLow,
  'speed-medium': IconSVG.SpeedMedium,
  'speed-test': IconSVG.SpeedTest,
  ssid: IconSVG.SSID,
  'ssid-threat': IconSVG.SSIDThreat,
  star: IconSVG.Star,
  'star-filled': IconSVG.StarFilled,
  stop: IconSVG.Stop,
  sun: IconSVG.Sun,
  switch: IconSVG.Switch,
  table: IconSVG.Table,
  tablet: IconSVG.Tablet,
  tag: IconSVG.Tag,
  template: IconSVG.Template,
  test: IconSVG.Test,
  'thumbs-down': IconSVG.ThumbsDown,
  'thumbs-up': IconSVG.ThumbsUp,
  toolbox: IconSVG.Toolbox,
  toolshed: IconSVG.Toolshed,
  topology: IconSVG.Topology,
  'traffic-light': IconSVG.TrafficLight,
  'traffic-shaping': IconSVG.TrafficShaping,
  'trash-can': IconSVG.TrashCan,
  tunnel: IconSVG.Tunnel,
  twinkle: IconSVG.Twinkle,
  undo: IconSVG.Undo,
  unhealthy: IconSVG.Unhealthy,
  upgrading: IconSVG.Upgrading,
  upload: IconSVG.Upload,
  user: IconSVG.User,
  users: IconSVG.Users,
  version: IconSVG.Version,
  view: IconSVG.View,
  'virtual-device': IconSVG.VirtualDevice,
  vlan: IconSVG.VLAN,
  vpn: IconSVG.VPN,
  vulnerability: IconSVG.Vulnerability,
  warning: IconSVG.Warning,
  webhook: IconSVG.Webhook,
  width: IconSVG.Width,
  wifi: IconSVG.WiFi,
  'wifi-qr': IconSVG.WiFiQR,
  wired: IconSVG.Wired,
  wireless: IconSVG.Wireless,
  'wireless-ids': IconSVG.WirelessIDS,
  wireguard: IconSVG.WireGuard,
  workbench: IconSVG.Workbench,
  wrench: IconSVG.Wrench,
} as const;

export const IconValues = Object.keys(Icons);
export type IconName = keyof typeof Icons;
export const IconNames = Object.keys(Icons) as readonly IconName[];
export { ICON_SNAPSHOT_ORDER } from './iconSnapshotOrder';

/** A–Z order for Storybook docs only (not for Chromatic baselines). */
export const IconNamesAlphabetical = [...IconNames].sort((a, b) =>
  a.localeCompare(b),
) as IconName[];

export interface IconProps {
  /**
   * Accepts any color value from our [colorset](/?path=/docs/colors).
   */
  color?: ColorProps;
  /**
   * Set which icon to display.
   */
  icon: IconName;
  /**
   * Set whether the icon is internal.
   */
  internal?: boolean;
  /**
   * Set a size of the component.
   */
  size?: IconSize;
  /**
   * Set a variant of the icon.
   */
  variant?: VariantProp | 'inherit';
}

const BaseSVG = styled('svg', {
  display: 'inline-block',
  flexGrow: 0,
  flexShrink: 0,

  variants: {
    variant: {
      alternative: { ...getVariantStyles('alternative'), color: variantIconColor },
      attention: { ...getVariantStyles('attention'), color: variantIconColor },
      brand: { ...getVariantStyles('brand'), color: variantIconColor },
      negative: { ...getVariantStyles('negative'), color: variantIconColor },
      neutral: { ...getVariantStyles('neutral'), color: variantIconColor },
      positive: { ...getVariantStyles('positive'), color: variantIconColor },
      inherit: { color: 'inherit' },
    },
    internal: {
      true: { ...getVariantStyles('neutral', true), color: variantIconColor },
      false: {},
    },
  },
});
BaseSVG.displayName = 'BaseSVG';

export function Icon({ color, icon, internal, size = 16, variant, ...remaining }: IconProps) {
  const NamedIcon = Icons[icon] as React.ComponentType<SVGAttributes<SVGSVGElement>> | undefined;

  if (!NamedIcon) {
    // eslint-disable-next-line no-console
    console.error(`Missing icon named ${icon}`);
    return null;
  }

  return (
    <BaseSVG
      as={NamedIcon}
      aria-hidden
      width={size}
      height={size}
      internal={internal}
      variant={variant}
      css={colorCSS(color?.dark, color?.light)}
      {...remaining}
    />
  );
}
